/**
 * 工作台横向柱状图
 * @param unit 单位
 * @param xData x轴数据
 * @param dataArr [{name:'',data:[]}]y轴数据合集
 */
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let colorList = [
    { color: "#59A3F3", color1: "#92D0FA" },
    { color: "#9C87E6", color1: "#BAA7FB" },
  ];
  let option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    legend: {
      top: "bottom",
    },
    grid: {
      left: "3%",
      right: "3%",
      bottom: "30px",
      top: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      boundaryGap: [0, 0.01],
      axisLine: {
        show: false,
      },
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      data: paramObj.xData,
      inverse: true,
      axisLine: {
        lineStyle: {
          color: "#999",
        },
      },
      axisTick: {
        lineStyle: {
          color: "#999",
        },
      },
    },
    series: [],
  };
  paramObj.dataArr.forEach((v, i) => {
    option.series.push({
      name: v.name,
      type: "bar",
      data: v.data,
      barMaxWidth: 16,
      itemStyle: {
        borderRadius: [0, 10, 10, 0],
        color: {
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: colorList[i].color,
            },
            {
              offset: 1,
              color: colorList[i].color1,
            },
          ],
        },
      },
      showBackground: true,
      backgroundStyle: {
        color: "rgba(180, 180, 180, 0.2)",
      },
    });
  });

  return option;
}
